const backgroundHandle = (url) => {
  return { 
    backgroundImage: `url("${url}")`,
     backgroundSize: 'contain',
     backgroundPosition: 'center',
     backgroundRepeat:'no-repeat',
  }
}
export default backgroundHandle